import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { localize } from 'wanderu-i18n';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './LinkRow.scss';

function LinkRow(props) {
    const {
        data = [],
        i18nMoney,
    } = props;

    return (
        <ul className={styles.list}>
            {data.map((row) => (
                <li
                    className={styles.item}
                    key={row.url}
                >
                    <A
                        className={styles.itemLink}
                        href={row.url}
                        prependLocale={!!row.isUiReact}
                        // Always native: LinkRow is rendered inside the homepage
                        // interlink grid, which only feeds c2c route data (/bus/*,
                        // /train/*). Full page navigation is required so the
                        // experiment-router proxy can intercept these requests.
                        native
                    >
                        <span className={styles.itemLeft}>
                            {row.left}
                        </span>
                    </A>
                    {row.right && (
                        <span className={styles.itemRight}>
                            {`${i18nMoney(row.right).format()}+`}
                        </span>
                    )}
                </li>
            ))}
        </ul>
    );
}

LinkRow.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        left: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string,
        ]).isRequired,
        right: PropTypes.number,
        url: PropTypes.string.isRequired,
    })),
    i18nMoney: PropTypes.func,
};

export {
    LinkRow,
};

const LocalizedLinkRow = localize(LinkRow, ['i18nMoney']);
export default LocalizedLinkRow;
